import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-KjVIQqaY.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-OiOYIWNt.js';
import '../../chunks/bundle-olZmltOQ.js';
import '../../chunks/bundle-vAvSNdmj.js';
import '../../chunks/bundle-t6JaUd1b.js';
import '../../chunks/bundle-rcUMtSzr.js';
import '../../chunks/bundle-XlrrUjEJ.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-mxq273ll.js';
import '../../chunks/bundle-zL2GggA_.js';
import 'dompurify';
import '../../chunks/bundle-mO3J4SXS.js';
import '../../chunks/bundle-Q-3uYmLU.js';
import '../../chunks/bundle-iGWTklyk.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-f-bQSvmA.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-NZcldiSn.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-2axFKCIx.js';
import '../../chunks/bundle-nyXhTs2k.js';
import '../../chunks/bundle-jJZAQH44.js';
import '../../chunks/bundle-79RbKDD4.js';
import '../../chunks/bundle-l9d09gzQ.js';
import '../../chunks/bundle-KF1IhHsV.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-hEvM6x_9.js';
import '../../chunks/bundle-21p8ODP_.js';
import '../../chunks/bundle-gdweDZjg.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-q1M15U1p.js';
import 'react-dom';
import '../../chunks/bundle-ior2BlUD.js';
import '../../chunks/bundle-joPrRU5E.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
